import { state } from "../state/workspaceStore.js";
import { clone } from "../utils/domain/model.js";
import { head } from "../components/common/PageHeader.jsx";
import { esc, initials } from "../utils/format.js";
import { field, errorSlot, btn } from "../components/forms/FormControls.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function profile() {
  if (!state.profileDraft) state.profileDraft = clone(state.db.profile);
  let p = state.profileDraft;
  return (
    <>
      {head(
        "ACCOUNT",
        "Admin profile",
        "Business identity and workspace preferences.",
      )}
      {
        <form id={"profile-form"} className={"grid-two"}>
          <section className={"card"}>
            <div className={"profile-summary"}>
              {p.avatar ? (
                <img
                  className={"profile-avatar"}
                  src={esc(p.avatar)}
                  alt={esc(p.name) + " avatar preview"}
                />
              ) : (
                <span className={"profile-avatar initials"}>
                  {initials(p.name)}
                </span>
              )}
              <div>
                <h2>{esc(p.name)}</h2>
                <p>
                  {esc(p.designation)}
                  <br />
                  {esc(p.company)}
                </p>
              </div>
            </div>
            <div className={"form-grid"}>
              {field("Name *", "name", p.name, "text", "required")}
              {field(
                "Designation *",
                "designation",
                p.designation,
                "text",
                "required",
              )}
              {field("Company *", "company", p.company, "text", "required")}
              {field("Brand *", "brand", p.brand, "text", "required")}
              {field(
                "Business email *",
                "businessEmail",
                p.businessEmail,
                "email",
                "required",
              )}
              {field("Business contact *", "phone", p.phone, "tel", "required")}
            </div>
            <p className={"hint"}>
              {
                "The email is a business contact, not a verified personal email."
              }
            </p>
            <button className={"btn"} type={"submit"}>
              {"Save changes"}
            </button>
            {errorSlot()}
          </section>
          <section className={"card"}>
            <h2>{"Profile photograph"}</h2>
            <label className={"field"}>
              <span>{"Upload avatar (JPEG, PNG or WebP; max 2 MB)"}</span>
              <input
                id={"avatar-image"}
                type={"file"}
                accept={"image/jpeg,image/png,image/webp"}
              />
            </label>
            {btn("Remove avatar", 'data-action="remove-avatar"', true)}
            <p className={"hint"}>
              {
                "Your initials are used until a photograph is supplied. Save changes to persist the preview."
              }
            </p>
            <div className={"divider"}></div>
            <h2>{"Local demo account"}</h2>
            <p className={"hint"}>
              {esc(state.activeAccount?.name)}
              {" \xB7 "}
              {esc(state.activeAccount?.email)}
              <br />
              {
                "This browser stores demo business data; production requires server-side authentication and authorization."
              }
            </p>
            <h2>{"Workspace data"}</h2>
            {btn("Export data backup", 'data-action="export-data"', true)}
            <div className={"space-top"}>
              {btn("Log out", 'data-action="logout"', true)}
            </div>
            <div className={"space-top"}>
              {btn("Reset example records", 'data-confirm="reset"', true)}
            </div>
          </section>
        </form>
      }
    </>
  );
}
export default function ProfilePage({ recordId } = {}) {
  return tableViews(profile());
}
